(function () {
    'use strict';

    angular.module("imApp").factory("factoringBuntsComponentService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1954,
                    parameters: parms || {}
                });
            },
            createNewBunts: function (setting) {
                return $ihttp.post({
                    method: 1957,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
